__turbopack_context__.v({
  "lightningCell": "styles-module__7b-dWq__lightningCell",
  "mevProtectionCell": "styles-module__7b-dWq__mevProtectionCell",
  "tradingCell": "styles-module__7b-dWq__tradingCell",
});
